/**
 * Generated by scripts/design-system/regenerate-design-system.cjs.
 * Source spec hash: c17360effe8c45050d447a2335083de154e03ef133fef9dc941f0a0d397e30f9
 */
import {
  base_colorAction,
  base_contentBackground,
  overlay_backgroundNotFocused,
} from 'ext-ui/style/colors'
import {
  cornerRadius,
  spacing,
} from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`

  .overlay {
    align-items: center;
    background: ${overlay_backgroundNotFocused};
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    overflow-y: auto;
    padding: ${spacing(8)};
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .panel {
    align-items: flex-start;
    background: ${base_contentBackground};
    border-radius: ${cornerRadius};
    box-shadow: 0px 3px 5px 0px rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
    gap: ${spacing(10)};
    max-width: 700px;
    padding: ${spacing(10)};
    position: relative;
    width: 100%;
    flex-shrink: 0;
    margin: auto;
  }

  .panel:focus-visible {
    outline: 2px solid ${base_colorAction};
    outline-offset: 2px;
  }

  .close {
    align-items: center;
    background: transparent;
    border: 0;
    cursor: pointer;
    display: inline-flex;
    font-size: 24px;
    justify-content: center;
    line-height: 1;
    padding: 0;
    position: absolute;
    right: ${spacing(4)};
    top: ${spacing(4)};
  }

  .decoration {
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }

  .title,
  .description,
  .body,
  .footer {
    min-width: 0;
  }

  .footer {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
`
